import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-classroom-header',
    templateUrl: './classroom-header.component.html',
    styleUrls: ['./classroom-header.component.scss'],
    standalone: false
})
export class ClassroomHeaderComponent implements OnInit {
  @Input() programName: string = 'WAH: Principles of Fall Protection';
  @Input() programId: string = 'WAH-123456';
  constructor() { }

  ngOnInit(): void {
  }

}
